﻿export const modal = (function () {
    class Modal {
        constructor(name = 'ppModal', title = '', size = undefined, closeButtonHas = true, footerButtonsArr = []) {
            
            this.name = name;
            this.title;
            this._title = title;
            this.size = (size == undefined) ? '' : (`modal-${size}`);
            this.content;
            this._content;
            this.closeButtonHas = closeButtonHas;
            this.footerButtonsArr = footerButtonsArr;

            this._modal = document.createElement('div');
            this._modalDialog = document.createElement('div');
            this._modal.appendChild(this._modalDialog);
            this._modalContent = document.createElement('div');
            this._modalDialog.appendChild(this._modalContent);
            this._modalHeader = document.createElement('div');
            this._modalContent.appendChild(this._modalHeader);
            this._modalBody = document.createElement('div');
            this._modalContent.appendChild(this._modalBody);
            this._modalTitle = document.createElement('h5');
            this._modalHeader.appendChild(this._modalTitle);

            this._modalFooter;
            this._modalCloseButton;
            this._modalCloseButtonIcon;

            this._modal.tabIndex = -1;
            this._modal.classList.add('modal');
            this._modal.setAttribute('role', 'dialog');
            this._modalDialog.setAttribute('role', 'document');
            if (this.size != "")
                this._modalDialog.classList.add(this.size);
            this._modalDialog.classList.add('modal-dialog');
            this._modalContent.classList.add('modal-content');
            this._modalHeader.classList.add('modal-header');
            this._modalTitle.textContent = this.title;
            this._modalTitle.classList.add('modal-title');
            this._modalBody.classList.add('modal-body');

            if (this.closeButtonHas) {
                this._modalCloseButton = document.createElement('button');
                this._modalCloseButtonIcon = document.createElement('span');
                this._modalCloseButton.appendChild(this._modalCloseButtonIcon);

                this._modalCloseButton.type = 'button';
                this._modalCloseButton.classList.add('close');
                this._modalCloseButton.setAttribute('data-dismiss', 'modal');
                this._modalCloseButton.setAttribute('aria-label', 'close');
                this._modalCloseButtonIcon.setAttribute('aria-hidden', 'true');
                this._modalCloseButtonIcon.textContent = "&times;";
            }

            if (Array.isArray(this.footerButtonsArr) && this.footerButtonsArr.length) {
                this._modalFooter = document.createElement('div');
                this._modalContent.appendChild(this._modalFooter);
                this._modalFooter.classList.add('modal-footer');

                for (const item of this.footerButtonsArr) {
                    this._modalFooter.appendChild(item);
                }
            }
            this._spinner = document.createElement('div');
            this._spinner.classList.add('d-flex', 'justify-content-center');
            this._spinner.id = 'spinnerContainer';

            this._spinnerItself = document.createElement('span');
            this._spinnerItself.classList.add('spinner-border', 'align-self-center');
            this._spinnerItself.id = 'spinner';
            this._spinnerItself.setAttribute('role', 'status');
            this._spinnerItself.setAttribute('area-hidden', 'true');

            this._spinner.appendChild(this._spinnerItself);
        }

        get title() {
            return this._title;
        }

        set title(value) {
            this._title = value;
            this._modalTitle.textContent = this._title;
        }

        get content() {
            return this._content;
        }

        set content(value) {
            this._content = value;
            this._modalBody.innerHTML = this._content;
        }

        show() {
            $(this._modal).modal('show');
        }

        hide() {
            $(this._modal).modal('hide');
        }

        clear() {
            for (let elem of this._modalBody.childNodes)
                elem.remove();
            $(this._modalBody).children().remove();
        }

        toggle() {
            $(this._modal).modal('toggle');
        }

        getModal() {
            return this._modal;
        }

        append(content) {
            this._modalBody.append(content);
        }

        appendAsHtml(html) {
            $(this._modalBody).append(html);
        }

        addSpinner() {
            this._modalBody.append(this._spinner);
        }

        removeSpinner() {
            if ($(this._modalBody).find(this._spinner).length > 0)
                this._modalBody.removeChild(this._spinner);
        }

        prepend(content) {
            this._modalBody.prepend(content);
        }

        event(event, callback) {
            $(this._modal).on(event, callback);
        }
    }

    return {
        Modal
    }
})();